import { render, staticRenderFns } from "./TreatmentModal.vue?vue&type=template&id=25933cb5&"
import script from "./TreatmentModal.vue?vue&type=script&lang=js&"
export * from "./TreatmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports